import React, { useState } from "react";
import Edit_MRM from "./edit_MRM/Edit_MRM";
import MRM_Form from "./mrm_Form/MRM_Form";
import MRM_table from "./mrm_table/MRM_table";

function MRM() {
  const [isEdit, setIsEdit] = useState(false);

  return (
    <section className="Imperiality">
      {isEdit ? (
        <Edit_MRM onCancel={() => setIsEdit(false)} />
      ) : (
        <>
          <div className="imperiality_Form_div">
            <MRM_Form />
          </div>

          <div className="imperiality_table_div">
            <MRM_table onEdit={() => setIsEdit(true)} />
          </div>
        </>
      )}
    </section>
  );
}

export default MRM;
